import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { MenuItem } from 'primeng/api';
import { AuthService } from 'src/app/core/auth/auth-service.service';
import { CommonService } from 'src/app/services/common.service';
import { GooglePickerService } from 'src/app/shared/google-picker/google-picker.service';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: false
})
export class NavbarComponent {
    menuItems: MenuItem[] = [];
    companyName: string = ""
    language: string = 'nl';
    selected: string = 'NL';

    constructor(
        private authService: AuthService,
        private commonService: CommonService,
        private cookieService: CookieService,
        private translate: TranslateService,
        private googlePickerService: GooglePickerService,
    ) {
    }

    ngOnInit() {
        this.companyName = this.commonService.companyName;
        if (!window.location.href.includes('support')) {
            this.menuItems = this.getMenuItems();
        } else {
            this.menuItems = this.getSupportMenuItems();
        }
    }

    getMenuItems() {
        return [
            {
                label: this.translate.instant('Users'),
                styleClass: 'menucus',
                routerLink: ['/users']
            },
            {
                label: this.translate.instant('Contacts'),
                styleClass: 'menucus',
                routerLink: ['/contacts']
            },
            {
                label: this.translate.instant('Standard Types'),
                styleClass: 'menucus',
                routerLink: ['/standard-types']
            },
            {
                label: this.translate.instant('Portal'),
                styleClass: 'menucus',
                items: [
                    {
                        label: this.translate.instant('Template Folders'),
                        styleClass: 'menucus',
                        routerLink: ['/template-folders']
                    },

                    {
                        label: this.translate.instant('Synchronize Folders'),
                        styleClass: 'menucus',
                        routerLink: ['/sync-folders']
                    },
                    {
                        label: this.translate.instant('Document Labels'),
                        styleClass: 'menucus',
                        routerLink: ['/documentslabels']
                    }
                ]
            },

            {
                label: this.translate.instant('Mail'),
                styleClass: 'menucus',
                routerLink: ['/mail']
            },
            {
                label: this.translate.instant('Invoices'),
                styleClass: 'menucus',
                routerLink: ['/invoices']
            },
            {
                label: this.translate.instant('Routes'),
                styleClass: 'menucus',
                routerLink: ['/routes']
            },
            {
                label: this.translate.instant('Touch'),
                styleClass: 'menucus',
                routerLink: ['/touch']
            },
            {
                label: this.translate.instant("Download"),
                styleClass: 'menucus',
                routerLink: ['/download']
            },
            {
                label: this.translate.instant("Log Download"),
                styleClass: 'menucus',
                routerLink: ['/logDownload']
            }
        ];
    }

    getSupportMenuItems() {
        return [
            {
                label: this.translate.instant('Domains'),
                styleClass: 'menucus',
                routerLink: ['/support']
            }
        ];
    }
}
